import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import iconLoadingIA from '../../imagens/ialoading.gif';
import { parserLocalProdutos } from '../../utils/parserProdutos';
import { organizarListaComIA } from '../../services/iaLista';
import RemoveBackgroundModal from '../RemoveBackgroundModal';

const tabs = [
  { id: 'lista', label: 'Lista', icon: 'fa-list-ul' },
  { id: 'buscar', label: 'Buscar', icon: 'fa-magnifying-glass' },
  { id: 'upload', label: 'Upload', icon: 'fa-cloud-arrow-up' },
];

function AdicionarProdutos({ produtos, setVisivel, setProdutos, onAddProdutos, setProdutoSelecionado, user, creditos, setCreditos }) {
  const [inputbuscar, setInputBuscar] = useState('');
  const [imagens, setImagens] = useState([]);
  const [loadingimagens, setLoadingImagens] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('lista');

  const fileUploadRef = React.useRef(null);

  const [imagemParaProcessar, setImagemParaProcessar] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loadingIA, setLoadingIA] = useState(false);

  const [textareaValue, setTextareaValue] = useState('');
  const [loadingLista, setLoadingLista] = useState(false);
  const [statusLista, setStatusLista] = useState(null); // {tipo, txt}

  const LIMITE_PRODUTOS = 10;

  const buscarImagem = async (termo) => {
    setLoadingImagens(true);
    try {
      const res = await fetch(
        `https://api-images2.crieoferta.com.br/search-show-fast?description=${encodeURIComponent(termo)}`
      );
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const divs = Array.from(doc.querySelectorAll('.item-figura[data-src]'));
      const srcs = divs.map(d => d.getAttribute('data-src'));
      const nomes = divs.map(d =>
        (d.getAttribute('data-desc-title') || '').replace(/-/g, ' ').replace(/\s+/g, ' ').trim()
      );

      if (srcs.length === 0) {
        setImagens([]);
        return;
      }

      const fd = new FormData();
      srcs.forEach(src => fd.append('srcs[]', src));
      const aliasRes = await fetch('https://crieoferta.com/bancodeimagens/resolver_aliases', {
        method: 'POST',
        body: fd,
      });
      const aliasJson = await aliasRes.json();

      const resultado = (aliasJson.resolvidos || [])
        .map((r, i) => ({ nome: nomes[i], imagem: r.resolved_src, ativo: r.ativo }))
        .filter(r => r.ativo);

      setImagens(resultado);
    } catch (err) {
      console.error(err);
      alert('Erro na requisição');
    } finally {
      setLoadingImagens(false);
    }
  };

  const adicionarProduto = async (nome, imagem, preco = '0,00', unidade = 'UNIDADE', extras = {}) => {
    if (produtos.length >= LIMITE_PRODUTOS) {
      alert(`Você pode adicionar no máximo ${LIMITE_PRODUTOS} produtos.`);
      return;
    }

    setProdutos((prev) => [...prev, { nome, imagem, preco }]);

    const urlParams = new URLSearchParams(window.location.search);
    const currentId = urlParams.get('id');

    const formData = new FormData();
    formData.append('id_encarte', currentId);
    formData.append('titulo', nome);
    formData.append('imagem', imagem);
    formData.append('preco', preco);
    formData.append('unidade', unidade);
    Object.entries(extras).forEach(([k, v]) => {
      if (v !== undefined && v !== null) formData.append(k, v);
    });

    try {
      const response = await fetch('https://videooferta.com/api/adicionar-produto.php', {
        method: 'POST',
        body: formData,
      });
      const data = await response.json();
      if (data.success) {
        onAddProdutos();
        if (extras.__navigateToEditar) {
          setProdutoSelecionado(data.data);
          setVisivel('editar-produto');
        }
      } else {
        console.error('Erro ao salvar produto:', data.error);
      }
    } catch (err) {
      console.error('Erro ao salvar produto:', err);
    }
  };

  const fazerUpload = () => fileUploadRef.current.click();

  const handleUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    setImagemParaProcessar(file);
    setShowModal(true);
  };

  const processarImagem = async (removerFundo = false) => {
    if (!imagemParaProcessar) return;
    try {
      const formData = new FormData();
      formData.append('imagem', imagemParaProcessar);
      if (removerFundo) {
        setLoadingIA(true);
        await Promise.resolve();
      } else {
        setLoading(true);
        setShowModal(false);
      }
      const endpoint = removerFundo
        ? 'https://videooferta.com/api/removebg.php'
        : 'https://videooferta.com/api/uploadImagem.php';
      const response = await fetch(endpoint, { method: 'POST', body: formData });
      if (!response.ok) throw new Error('Erro ao processar a imagem');
      const data = await response.json();
      if (data?.url) {
        const nomeProduto = imagemParaProcessar.name.replace(/\.[^/.]+$/, '');
        adicionarProduto(nomeProduto, data.url);
        setVisivel('produtos');
      } else {
        alert(data.error || 'Erro ao processar a imagem.');
      }
    } catch (error) {
      console.error(error);
      alert('Erro ao processar a imagem.');
    } finally {
      if (removerFundo) setLoadingIA(false);
      if (!removerFundo) setLoading(false);
      setShowModal(false);
      setImagemParaProcessar(null);
    }
  };

  const buscarImagemLista = async (termo) => {
    try {
      const res = await fetch(
        `https://api-images2.crieoferta.com.br/search-show-fast?description=${encodeURIComponent(termo)}`
      );
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const divs = Array.from(doc.querySelectorAll('.item-figura[data-src]'));

      if (divs.length === 0) return 'https://d1038wlozf3qar.cloudfront.net/imagens/produto-sem-imagem.png';

      const src = divs[0].getAttribute('data-src');
      const fd = new FormData();
      fd.append('srcs[]', src);
      const aliasRes = await fetch('https://crieoferta.com/bancodeimagens/resolver_aliases', {
        method: 'POST',
        body: fd,
      });
      const aliasJson = await aliasRes.json();
      const first = (aliasJson.resolvidos || [])[0];

      if (first && first.ativo) return first.resolved_src;
      return 'https://d1038wlozf3qar.cloudfront.net/imagens/produto-sem-imagem.png';
    } catch (err) {
      console.error(err);
      return 'https://d1038wlozf3qar.cloudfront.net/imagens/produto-sem-imagem.png';
    }
  };

  const parseProduto = (texto) => {
    // Mantido como fallback simples (caso parser canonico devolva nada)
    texto = texto.trim();
    let match = texto.match(
      /^(.+?)\s+(\d+)\s*(kg|g|un|ml|l|lt|cx|pct|unidade)\s+(\d+(?:[.,]\d{1,2}))$/i
    );
    if (match) {
      return {
        nome: `${match[1].trim()} ${match[2]}${match[3]}`,
        preco: match[4].replace('.', ','),
        unidade: match[3],
      };
    }
    match = texto.match(/^(.+?)\s+(\d+)\s*(kg|g|un|ml|l|lt|cx|pct|unidade)$/i);
    if (match) {
      return {
        nome: `${match[1].trim()} ${match[2]}${match[3]}`,
        preco: '0,00',
        unidade: match[3],
      };
    }
    match = texto.match(/^(.+?)\s+(\d+(?:[.,]\d{1,2}))$/i);
    if (match) {
      return { nome: match[1].trim(), preco: match[2].replace('.', ','), unidade: '' };
    }
    return { nome: texto, preco: '0,00', unidade: '' };
  };

  // Adicionar produtos extraídos do parser canônico (com label/tipo)
  const adicionarProdutosCanonicos = async (produtosParsed) => {
    const vagas = LIMITE_PRODUTOS - produtos.length;
    for (const p of produtosParsed.slice(0, vagas)) {
      const imagem = await buscarImagemLista(p.nome);
      const extras = {};
      // Mapeia para campos do backend
      if (p.tipopreco === 'dexpory') {
        extras.tipopreco = 'dexpory';
        extras.precode = p.precode;
        extras.precopor = p.precopor;
      } else if (p.tipopreco === 'pagamento') {
        // Backend ainda não conhece 'pagamento'; mapeamos como dexpory com rótulos custom
        extras.tipopreco = 'dexpory';
        extras.precode = p.precoPrincipal;
        extras.precopor = p.precoSecundario;
        extras.label_preco_principal = p.labelPrecoPrincipal;
        extras.label_preco_secundario = p.labelPrecoSecundario;
      } else {
        extras.tipopreco = 'simples';
      }
      if (p.observacao) extras.observacoes = p.observacao;
      const precoBase = p.preco || p.precopor || p.precoPrincipal || '0,00';
      await adicionarProduto(p.nome, imagem, precoBase, p.unidade || '', extras);
    }
  };

  const processarListaProdutos = async (opts = {}) => {
    let texto = textareaValue;
    if (!texto.trim()) return;
    const vagas = LIMITE_PRODUTOS - produtos.length;
    if (vagas <= 0) {
      alert(`Você já atingiu o limite de ${LIMITE_PRODUTOS} produtos.`);
      return;
    }

    setLoadingLista(true);
    setStatusLista(null);
    try {
      // 1) SEMPRE chama a IA primeiro (corrige ortografia/formato/unidades),
      //    independente de a lista parecer "limpa" ou não. Só pula em chamada
      //    recursiva (opts.semIA) para evitar loop.
      let parsed = [];
      if (!opts.semIA) {
        setStatusLista({ tipo: 'info', txt: 'Organizando com IA (corrigindo ortografia e formato)…' });
        try {
          const limpo = await organizarListaComIA(texto);
          if (limpo && limpo.trim()) {
            texto = limpo;
            setTextareaValue(limpo);
          }
        } catch (e) {
          console.warn('IA falhou:', e?.message);
          setStatusLista({
            tipo: 'warn',
            txt: `IA indisponível — usando interpretação simples. (${e?.message || 'erro desconhecido'})`,
          });
        }
      }

      // 2) parser local sobre o texto (já corrigido pela IA, se foi possível)
      parsed = parserLocalProdutos(texto);

      if (parsed.length > 0) {
        await adicionarProdutosCanonicos(parsed);
      } else {
        // fallback antigo linha-a-linha
        const linhas = texto.split('\n').map((l) => l.trim()).filter(Boolean);
        for (const linha of linhas.slice(0, vagas)) {
          const { nome, preco, unidade } = parseProduto(linha);
          const imagem = await buscarImagemLista(nome);
          await adicionarProduto(nome, imagem, preco, unidade);
        }
      }
      setTextareaValue('');
      // mantém statusLista se foi warn (para o usuário ver o motivo)
      setStatusLista((s) => (s && s.tipo === 'warn' ? s : null));
      setVisivel('locucao');
    } finally {
      setLoadingLista(false);
    }
  };

  return (
    <div className="col2 prod-panel">
      {/* ─── Header ─── */}
      <motion.div
        className="prod-header"
        initial={{ opacity: 0, y: -12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35 }}
      >
        <div className="prod-header__top">
          <div className="prod-header__title-group">
            <button
              className="prod-back-btn"
              onClick={() => setVisivel('produtos')}
            >
              <i className="fa-solid fa-arrow-left" />
            </button>
            <div>
              <h2 className="prod-header__title">Adicionar produtos</h2>
              <p className="prod-header__subtitle">
                {produtos.length}/{LIMITE_PRODUTOS} produtos
              </p>
            </div>
          </div>
          <button
            className="prod-header__close"
            onClick={() => setVisivel('')}
            aria-label="Fechar"
          >
            <i className="fa-solid fa-xmark" />
          </button>
        </div>

        {/* Tabs */}
        <div className="add-tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`add-tab${activeTab === tab.id ? ' add-tab--active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <i className={`fa-solid ${tab.icon}`} />
              {tab.label}
            </button>
          ))}
        </div>
      </motion.div>

      {/* ─── Body ─── */}
      <motion.div
        className="prod-body"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1, duration: 0.35 }}
      >
        <AnimatePresence mode="wait">
          {/* Tab: Lista */}
          {activeTab === 'lista' && (
            <motion.div
              key="lista"
              initial={{ opacity: 0, x: -8 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 8 }}
              transition={{ duration: 0.2 }}
              className="add-tab-content"
            >
              <p className="add-hint">
                <i className="fa-solid fa-circle-info" style={{ marginRight: 6, color: '#73207C' }} />
                Cole uma lista de produtos (1 por linha):
              </p>
              <textarea
                className="add-textarea"
                rows={6}
                value={textareaValue}
                onChange={(e) => setTextareaValue(e.target.value)}
                placeholder={`Arroz 5kg 29,90\nFeijão 7,50\nÓleo de soja 8,99`}
              />
              {statusLista && (
                <div
                  style={{
                    margin: '8px 0',
                    padding: '10px 12px',
                    borderRadius: 12,
                    fontSize: 13,
                    border: '1px solid',
                    borderColor:
                      statusLista.tipo === 'warn' ? '#F5C2C7'
                      : statusLista.tipo === 'info' ? '#E8E1EF'
                      : '#BEE5EB',
                    background:
                      statusLista.tipo === 'warn' ? '#FFF5F6'
                      : statusLista.tipo === 'info' ? '#F5EDFA'
                      : '#E8F4FA',
                    color:
                      statusLista.tipo === 'warn' ? '#842029'
                      : '#3C005A',
                  }}
                >
                  <i
                    className={`fa-solid ${
                      statusLista.tipo === 'warn'
                        ? 'fa-triangle-exclamation'
                        : statusLista.tipo === 'info'
                        ? 'fa-wand-magic-sparkles'
                        : 'fa-circle-info'
                    }`}
                    style={{ marginRight: 6 }}
                  />
                  {statusLista.txt}
                </div>
              )}
              <button
                className="add-action-btn"
                disabled={loadingLista || !textareaValue.trim()}
                onClick={processarListaProdutos}
              >
                {loadingLista ? (
                  <>
                    <span className="prod-spinner-sm" /> Adicionando...
                  </>
                ) : (
                  <>
                    <i className="fa-solid fa-plus" /> Adicionar lista
                  </>
                )}
              </button>
            </motion.div>
          )}

          {/* Tab: Buscar */}
          {activeTab === 'buscar' && (
            <motion.div
              key="buscar"
              initial={{ opacity: 0, x: -8 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 8 }}
              transition={{ duration: 0.2 }}
              className="add-tab-content"
            >
              <p className="add-hint">
                <i className="fa-solid fa-circle-info" style={{ marginRight: 6, color: '#73207C' }} />
                Busque produtos no banco de imagens
              </p>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  buscarImagem(inputbuscar);
                }}
                className="edit-img-search"
              >
                <div className="edit-img-search__wrap">
                  <i className="fa-solid fa-magnifying-glass edit-img-search__icon" />
                  <input
                    type="text"
                    placeholder="Digite o nome do produto"
                    value={inputbuscar}
                    onChange={(e) => setInputBuscar(e.target.value)}
                    className="edit-img-search__input"
                  />
                  <button type="submit" className="edit-img-search__btn">
                    Buscar
                  </button>
                </div>
              </form>

              {loadingimagens ? (
                <div className="add-loading-row">
                  <span className="prod-spinner-sm" /> Carregando imagens...
                </div>
              ) : imagens.length > 0 ? (
                <div className="add-img-grid">
                  {imagens.map((img, i) => (
                    <motion.div
                      key={i}
                      className="add-img-card"
                      whileHover={{ scale: 1.04 }}
                      whileTap={{ scale: 0.97 }}
                      onClick={() => adicionarProduto(img.nome, img.imagem, '0,00', 'UNIDADE', { __navigateToEditar: true })}
                    >
                      <img src={img.imagem} alt={img.nome || 'Produto'} />
                      {img.nome && <span className="add-img-card__name">{img.nome}</span>}
                    </motion.div>
                  ))}
                </div>
              ) : null}
            </motion.div>
          )}

          {/* Tab: Upload */}
          {activeTab === 'upload' && (
            <motion.div
              key="upload"
              initial={{ opacity: 0, x: -8 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 8 }}
              transition={{ duration: 0.2 }}
              className="add-tab-content"
            >
              <div className="add-upload-zone" onClick={fazerUpload}>
                <i className="fa-solid fa-cloud-arrow-up add-upload-zone__icon" />
                <p className="add-upload-zone__title">
                  Clique para enviar uma imagem
                </p>
                <p className="add-upload-zone__hint">
                  JPG, PNG ou WebP • Máx 5 MB
                </p>
              </div>
              <input
                type="file"
                ref={fileUploadRef}
                style={{ display: 'none' }}
                accept="image/*"
                onChange={handleUpload}
              />
            </motion.div>
          )}
        </AnimatePresence>
      </motion.div>

      {/* Modal remover fundo */}
      <RemoveBackgroundModal
        open={showModal}
        onClose={() => { setShowModal(false); setImagemParaProcessar(null); }}
        source={imagemParaProcessar}
        userId={user?.id}
        creditos={creditos}
        onCreditosUpdate={(novo) => setCreditos && setCreditos(novo)}
        onConfirm={async (resultado) => {
          try {
            setLoading(true);
            const nomeProduto = imagemParaProcessar?.name?.replace(/\.[^/.]+$/, '') || 'Produto';
            let urlFinal = null;
            if (typeof resultado === 'string') {
              if (resultado.startsWith('data:')) {
                const blob = await (await fetch(resultado)).blob();
                const fd = new FormData();
                fd.append('imagem', blob, 'sem-fundo.png');
                const up = await fetch('https://videooferta.com/api/uploadImagem.php', {
                  method: 'POST', body: fd,
                });
                const upJ = await up.json();
                if (upJ?.url) urlFinal = upJ.url;
              } else {
                urlFinal = resultado;
              }
            } else {
              const fd = new FormData();
              fd.append('imagem', resultado);
              const up = await fetch('https://videooferta.com/api/uploadImagem.php', {
                method: 'POST', body: fd,
              });
              const upJ = await up.json();
              if (upJ?.url) urlFinal = upJ.url;
            }
            if (!urlFinal) throw new Error('URL não retornada');
            await adicionarProduto(nomeProduto, urlFinal, '0,00', '', { __navigateToEditar: true });
            setVisivel('produtos');
          } catch (e) {
            console.error(e);
            alert('Erro ao salvar imagem.');
          } finally {
            setLoading(false);
          }
        }}
      />
      {/* fim modal */}
    </div>
  );
}

export default AdicionarProdutos;
